import { Component } from "@angular/core";
import { Globals } from "src/app/services/globals";

interface PriceListRow {
    sku: string;
    printPrice: number;
    additionalPrice: number;
    shippingPrice: number;
}

@Component({
    selector: "price-list",
    templateUrl: "./price-list.component.html",
    styleUrls: ["./price-list.component.scss"],
    standalone: false,
})
export class PriceListComponent {
    constructor(public globals: Globals) {
    }

    get prices(): PriceListRow[] {
        const creditPrices = this.globals.storeSettings?.creditPrices ?? {};

        return Object.entries(creditPrices)
            .filter(([, price]) => price.printPrice !== 0)
            .map(([sku, price]) => ({
                sku,
                printPrice: price.printPrice,
                additionalPrice: price.additionalPrice,
                shippingPrice: price.shippingPrice,
            }))
            .sort((a, b) => a.sku.localeCompare(b.sku, undefined, {
                numeric: true,
                sensitivity: "base",
            }));
    }
}
